import { storageService } from '../services/storageService';
import { jwtUtils } from './jwtUtils';

export function getToken(): string | undefined {
    const token = storageService.getToken();
    return token?.access_token;
}

export function isAuthenticated(): boolean {
    const token = storageService.getToken();
    if (!token?.access_token) return false;
    
    // Check if token is expired
    return !jwtUtils.isTokenExpired(token.access_token);
}

export function getCurrentUser() {
    const token = storageService.getToken();
    if (!token?.access_token) return null;
    
    return jwtUtils.decodeToken(token.access_token);
}

export function getUserRoles(): string[] {
    const token = storageService.getToken();
    if (!token?.access_token) return [];
    
    return jwtUtils.getUserRoles(token.access_token);
}

export function getUserId(): string | null {
    const token = storageService.getToken();
    if (!token?.access_token) return null;
    
    return jwtUtils.getUserId(token.access_token);
}
